import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/legal",
    name: "Legal",
    component: () => import("../views/Legal.vue")
  },
  {
    path: "/commands",
    name: "Commands",
    component: () => import("../views/Commands.vue")
  },
  {
    path: "/premium",
    name: "Premium",
    component: () => import("../views/Premium.vue")
  },
  {
    path: "/dashboard/:id",
    name: "Server Settings",
    component: () => import("../views/Dashboard.vue"),
    children: [
      {
        path: "config",
        component: () => import("../components/General.vue")
      },
      {
        path: "welcomer",
        component: () => import("../components/Welcomer.vue")
      },
      {
        path: "logger",
        component: () => import("../components/Logger.vue")
      },
      {
        path: "automod",
        component: () => import("../components/Automod.vue")
      },
      {
        path: "punishments",
        component: () => import("../components/Punishments.vue")
      },
      {
        path: "commands",
        component: () => import("../components/Command.vue")
      },
      {
        path: "security",
        component: () => import("../components/Security.vue")
      }
    ]
  },
  {
    path: "/dashboard",
    name: "Select Server",
    component: () => import("../views/ServerSelect.vue")
  },
  {
    path: "/users/:id",
    name: "User Settings",
    component: () => import("../views/User.vue"),
    children: [
      {
        path: "subscriptions",
        component: () => import("../components/Subscriptions.vue")
      },
      {
        path: "beta",
        component: () => import("../components/BetaFeatures.vue")
      }
    ]
  },
  {
    path: "/gateway/verification/:id",
    name: "Gateway Verification",
    component: () => import("../views/GatewayVerification.vue")
  },
  {
    path: "*",
    name: "Error",
    component: () => import("../views/Error.vue")
  }
];

// beforeEnter: ensureAuthentication,
// function ensureAuthentication(to, from, next) {
//   if (!store.state.authenticated) {
//     next("/login");
//   } else {
//     next();
//   }
// }

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
